export const ROUTE_HOME = {
  path: '/home',
  name: 'home',
};

export const ROUTE_ABOUT = {
  path: '/about',
  name: 'about',
};

export const ROUTE_SIGN_IN = {
  path: '/sing-in',
  name: 'sign-in',
};

export const ROUTE_QR = {
  path: '/qr/:tipo',
  name: 'qr',
};


export const ROUTE_CAMERA = {
  path: '/camera',
  name: 'camera',
};

export const ROUTE_COLETA_LISTA = {
  path: '/coleta',
  name: 'coleta-lista',

};

export const ROUTE_COLETA_CADASTRO = {
  path: '/coleta/cadastro',
  name: 'coleta-cadastro',
}

export const ROUTE_PRESTACAOSERVICO = {
  path: '/prestacao_servico',
  name: 'prestacaoservico',
}

export const ROUTE_CADASTROVEICULO = {
  path: '/cadastroVeiculo',
  name: 'cadastroVeiculo',
}

export const ROUTE_CADASTROEQUIPAMENTO = {
  path: '/cadastroEquipamento',
  name: 'cadastroEquipamento',
}

export const ROUTE_CADASTROOS = {
  path: '/cadastroOS',
  name: 'cadastroos',
}

export const ROUTE_CADASTROITEM = {
  path: '/cadastro-item',
  name: 'cadastro-item',
}

export const ROUTE_CLIENTE = {
  path: '/clientes',
  name: 'clientes',
}

export const ROUTE_PRODUTO = {
  path: '/produto',
  name: 'produto',
}

export const ROUTE_VENDEDOR = {
  path: '/vendedor',
  name: 'vendedor',
}

export const ROUTE_FORNECEDOR = {
  path: '/fornecedor',
  name: 'fornecedor',
}

export const ROUTE_VEICULO = {
  path: '/veiculo',
  name: 'veiculo',
}

export const ROUTE_PESQUISA = {
  path: '/pesquisa',
  name: 'pesquisa',
}